export const FETCH_EMOJI_REQUEST = "FETCH_EMOJI_REQUEST";
export const FETCH_EMOJI_SUCCESS = "FETCH_EMOJI_SUCCESS";
export const FETCH_EMOJI_FAILURE = "FETCH_EMOJI_FAILURE";